/* eslint-disable import/prefer-default-export */
export const fieldsMainProduct = [
  {
    key: 'checkbox',
    label: '',
    thClass: 'w-[10px]',
    tdClass: 'bg-[#FFECE9]',
  },
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize',
    tdClass: 'w-[600px] bg-[#FFECE9] text-[#222]',
  },
  {
    key: 'total',
    label: 'Jumlah',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize text-center',
    tdClass: 'bg-[#FFECE9] text-[#222]',
  },
]

export const fieldsAddonProduct = [
  {
    key: 'checkbox',
    label: '',
    thClass: 'w-[10px]',
    tdClass: '',
  },
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize',
    tdClass: 'w-[600px] text-[#222]',
  },
  {
    key: 'total',
    label: 'Jumlah',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize text-center',
    tdClass: 'text-[#222]',
  },
]

export const fieldsDiscountProduct = [
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize',
    tdClass: 'text-[#222]',
  },
  {
    key: 'total',
    label: 'Jumlah',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize',
    tdClass: 'text-[#222]',
  },
  {
    key: 'price',
    label: 'Harga Normal',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize',
    tdClass: 'text-[#222]',
  },
  {
    key: 'discount',
    label: 'Diskon',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize',
    tdClass: 'text-[#222] w-[150px]',
  },
  {
    key: 'final_price',
    label: 'Harga Paket',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize',
    tdClass: 'text-[#222]',
  },
]

export const fieldsBundling = [
  {
    key: 'no',
    label: 'No',
    thClass: 'font-[500] text-[#6e6b7b] !text-[14px] !capitalize bg-white',
    tdClass: 'text-[#6e6b7b]',
  },
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'font-[500] text-[#6e6b7b] !text-[14px] !capitalize bg-white',
    tdClass: 'text-[#6e6b7b]',
  },
  {
    key: 'qty',
    label: 'Jumlah',
    thClass:
      'font-[500] text-[#6e6b7b] !text-[14px] !capitalize text-center bg-white',
    tdClass: 'text-[#6e6b7b] text-center',
  },
]

/**
 * Validasi file video untuk upload produk
 * @param {File} file - File video yang akan divalidasi
 * @param {Object} options - Opsi validasi (opsional)
 * @param {Array} options.allowedExtensions - Ekstensi file yang diizinkan (default: ['mp4', 'mov', 'avi', 'mkv'])
 * @param {Array} options.allowedTypes - Tipe MIME yang diizinkan (default: ['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-matroska'])
 * @param {Number} options.minWidth - Lebar minimum video dalam pixel (default: 640)
 * @param {Number} options.minHeight - Tinggi minimum video dalam pixel (default: 480)
 * @param {Number} options.maxWidth - Lebar maksimum video dalam pixel (default: 1920)
 * @param {Number} options.maxHeight - Tinggi maksimum video dalam pixel (default: 1080)
 * @param {Number} options.minDuration - Durasi minimum video dalam detik (default: 1)
 * @param {Number} options.maxDuration - Durasi maksimum video dalam detik (default: 60)
 * @param {Number} options.maxSize - Ukuran maksimum file dalam bytes (default: 52428800 = 50MB)
 * @returns {Promise} Promise yang resolve dengan objek { valid: true, file, width, height, duration, size } jika valid,
 *                    atau resolve dengan objek { valid: false, error: 'pesan error' } jika tidak valid
 */
export const validateVideoUpload = (file, options = {}) => {
  const {
    allowedExtensions = ['mp4', 'mov', 'avi', 'mkv'],
    allowedTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-matroska'],
    minWidth = 640,
    minHeight = 480,
    maxWidth = 1920,
    maxHeight = 1080,
    minDuration = 1,
    maxDuration = 60,
    maxSize = 52428800, // 50MB default
  } = options

  return new Promise(resolve => {
    const fileName = file.name
    const fileType = file.type
    const fileSize = file.size

    // Check if the file extension is allowed
    const fileExtension = fileName
      .split('.')
      .pop()
      .toLowerCase()
    const isValidExtension = allowedExtensions.includes(fileExtension)

    // Check if the file type is allowed
    const isValidType = allowedTypes.includes(fileType)

    if (!isValidExtension || !isValidType) {
      resolve({
        valid: false,
        error: 'Format video tidak sesuai, silahkan coba lagi!',
      })
      return
    }

    // Check if the file size is within the limit
    if (fileSize > maxSize) {
      const maxSizeMB = (maxSize / 1048576).toFixed(2)
      resolve({
        valid: false,
        error: `Ukuran file terlalu besar! Maksimum ${maxSizeMB}MB`,
      })
      return
    }

    // Check video properties (resolution and duration)
    const video = document.createElement('video')
    const objectUrl = URL.createObjectURL(file)
    video.src = objectUrl
    video.preload = 'metadata'

    video.onloadedmetadata = () => {
      const { videoWidth, videoHeight, duration } = video

      // Clean up the object URL
      URL.revokeObjectURL(objectUrl)

      // Validate resolution
      if (videoWidth < minWidth || videoHeight < minHeight) {
        resolve({
          valid: false,
          error: `Resolusi video terlalu kecil! Minimum ${minWidth}x${minHeight}px`,
        })
        return
      }

      if (videoWidth > maxWidth || videoHeight > maxHeight) {
        resolve({
          valid: false,
          error: `Resolusi video terlalu besar! Maksimum ${maxWidth}x${maxHeight}px`,
        })
        return
      }

      // Validate duration
      if (duration < minDuration) {
        resolve({
          valid: false,
          error: `Durasi video terlalu pendek! Minimum ${minDuration} detik`,
        })
        return
      }

      if (duration > maxDuration) {
        resolve({
          valid: false,
          error: `Durasi video terlalu panjang! Maksimum ${maxDuration} detik`,
        })
        return
      }

      resolve({
        valid: true,
        originalFile: file,
        videoUrl: objectUrl,
        width: videoWidth,
        height: videoHeight,
        duration: duration.toFixed(2),
        size: fileSize,
        sizeInMB: (fileSize / 1048576).toFixed(2),
      })
    }

    video.onerror = () => {
      URL.revokeObjectURL(objectUrl)
      resolve({
        valid: false,
        error: 'Gagal memuat video, silahkan coba lagi!',
      })
    }
  })
}

/**
 * Validasi file gambar untuk upload produk
 * @param {File} file - File gambar yang akan divalidasi
 * @param {Object} options - Opsi validasi (opsional)
 * @param {Array} options.allowedExtensions - Ekstensi file yang diizinkan (default: ['jpg', 'jpeg', 'png'])
 * @param {Array} options.allowedTypes - Tipe MIME yang diizinkan (default: ['image/jpeg', 'image/jpg', 'image/png'])
 * @param {Number} options.minWidth - Lebar minimum gambar dalam pixel (default: 300)
 * @param {Number} options.minHeight - Tinggi minimum gambar dalam pixel (default: 300)
 * @param {Number} options.maxWidth - Lebar maksimum gambar dalam pixel (default: null = tidak ada batas)
 * @param {Number} options.maxHeight - Tinggi maksimum gambar dalam pixel (default: null = tidak ada batas)
 * @param {Number} options.maxSize - Ukuran maksimum file dalam bytes (default: 5242880 = 5MB)
 * @returns {Promise} Promise yang resolve dengan objek { valid: true, file, width, height, size } jika valid,
 *                    atau resolve dengan objek { valid: false, error: 'pesan error' } jika tidak valid
 */
export const validateImageUpload = (file, options = {}) => {
  const {
    allowedExtensions = ['jpg', 'jpeg', 'png'],
    allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'],
    minWidth = 300,
    minHeight = 300,
    maxWidth = null,
    maxHeight = null,
    maxSize = 5242880, // 5MB default
  } = options

  return new Promise(resolve => {
    const fileName = file.name
    const fileType = file.type
    const fileSize = file.size

    // Check if the file extension is allowed
    const fileExtension = fileName
      .split('.')
      .pop()
      .toLowerCase()
    const isValidExtension = allowedExtensions.includes(fileExtension)

    // Check if the file type is allowed
    const isValidType = allowedTypes.includes(fileType)

    if (!isValidExtension || !isValidType) {
      resolve({
        valid: false,
        error: 'Format gambar tidak sesuai, silahkan coba lagi!',
      })
      return
    }

    // Check if the file size is within the limit
    if (fileSize > maxSize) {
      const maxSizeMB = (maxSize / 1048576).toFixed(2)
      resolve({
        valid: false,
        error: `Ukuran file terlalu besar! Maksimum ${maxSizeMB}MB`,
      })
      return
    }

    // Check image dimensions
    const img = new Image()
    const objectUrl = URL.createObjectURL(file)
    img.src = objectUrl

    img.onload = () => {
      const { width, height } = img

      // Clean up the object URL
      URL.revokeObjectURL(objectUrl)

      // Check minimum dimensions
      if (width < minWidth || height < minHeight) {
        resolve({
          valid: false,
          error: `Ukuran gambar produk kurang dari ${minWidth}x${minHeight}px`,
        })
        return
      }

      // Check maximum dimensions if specified
      if (maxWidth && width > maxWidth) {
        resolve({
          valid: false,
          error: `Lebar gambar melebihi batas maksimum ${maxWidth}px`,
        })
        return
      }

      if (maxHeight && height > maxHeight) {
        resolve({
          valid: false,
          error: `Tinggi gambar melebihi batas maksimum ${maxHeight}px`,
        })
        return
      }

      // All validations passed
      resolve({
        valid: true,
        originalFile: file,
        imageUrl: objectUrl,
        width,
        height,
        size: fileSize,
        sizeInMB: (fileSize / 1048576).toFixed(2),
      })
    }

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl)
      resolve({
        valid: false,
        error: 'Gagal memuat gambar, silahkan coba lagi!',
      })
    }
  })
}
